// extracted by mini-css-extract-plugin
export var typingIndicator = "_oo-0";